<template>
  <div v-if="config" class="ui-nio-skeleton">
    <section v-for="(item, i) in config" :key="i" :style="item.style">
      <div v-if="item.type === 'banner'" :style="item.itemStyle || {}" class="ui-nio-skeleton__banner ui-nio-skeleton__block"></div>
      <div v-else-if="item.type === 'flex' && item.num"
           :style="item.style"
           class="ui-nio-skeleton__flex-wrap" :class="item.hasPadding ? 'has-padding' : ''">
        <div v-for="(flexItem, flexI) in item.num"
             :key="flexI"
             class="ui-nio-skeleton__flex-item ui-nio-skeleton__block"
             :class="item.round ? 'round' : ''"
             :style="item | flexItemStyle"></div>
      </div>
      <div v-else-if="item.type === 'custom'"
           :style="item.itemStyle || {}"
           class="ui-nio-skeleton__block"></div>
      <van-skeleton v-else :title="item.title"
                    :avatar="item.avatar"
                    :row="item.row" />
    </section>
  </div>
</template>

<script>
import Vue from 'vue';
import {Skeleton} from 'vant';

Vue.use(Skeleton);
export default {
  name: 'Skeleton',
  props: {
    config: {
      type: Array,
      default: null
    }
  },
  filters: {
    flexItemStyle (item){
      const col = item.col && item.col > 1 ? item.col : 1;
      const gap = item.gap || 10;
      const dis = `calc((100vw - ${gap * (col - 1)}px${item.hasPadding ? ' - 40px' : ''}) / ${col})`;

      return {
        width: dis, height: dis, marginBottom: `${gap}px`, ...item.itemStyle
      };
    }
  }
};
</script>

<style lang="scss" scoped>
$fill-color: #F5F5F5;
@keyframes skeletonBlink {
  50% {
    opacity: 0.6;
  }
}
.ui-nio-skeleton {
  &__banner {
    width: 100vw;
    height: 100vw;
    background-image: url('../../assets/images/icon/icon_logo_s.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 30px;
  }
  &__flex-wrap {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &.has-padding {
      padding: 0 20px;
    }
  }
  &__flex-item {
    box-sizing: border-box;
    &.round {
      border-radius: 50%;
    }
  }
  &__block {
    background-color: $fill-color;
    animation: skeletonBlink 1.2s ease-in-out infinite;
    box-sizing: border-box;
  }
}
</style>